import { restApiUrl, ipApiKey } from 'helpers/constants';

export const apiEndpoints: ApiEndpoints = {
  activityFeed: `${restApiUrl}activity_feed/algolia`,
  availableIntegrations: `${restApiUrl}integrations/available`,
  collaborators: `${restApiUrl}collaborators`,
  configuredIntegrations: `${restApiUrl}integrations/configured`,
  createOrganization: `${restApiUrl}/workspaces`,
  currentUser: `${restApiUrl}current_user`,
  deleteIntegration: `${restApiUrl}integration`,
  groups: `${restApiUrl}groups`,
  hasFolders: `${restApiUrl}integrations/has_folders/algolia`,
  integrations: `${restApiUrl}integrations`,
  integrationsStart: `${restApiUrl}integrations/start`,
  integrationsToken: `${restApiUrl}integrations/token`,
  organizations: `${restApiUrl}workspaces`,
  plans: `${restApiUrl}plans`,
  pusherAuth: `${restApiUrl}pusher/auth`,
  pins: `${restApiUrl}pins`,
  search: `${restApiUrl}search/algolia`,
  tokenAccess: `${restApiUrl}token/access/v2`,
  tokenRefresh: `${restApiUrl}token/refresh`,
  topCollaborators: `${restApiUrl}top_contacts/algolia`,
  updateUser: `${restApiUrl}users/me`,
  impersonate: `${restApiUrl}token/impersonate`,
};

export const apiOrganizationEndpoints: OrganizationEndpointUrls = (
  organizationId: string
): OrganizationEndpoints => ({
  billingInfo: `${restApiUrl}workspace/${organizationId}/billing`,
  disconnectIntegration: `${restApiUrl}workspace/${organizationId}/disconnect`,
  modifySubscription: `${restApiUrl}workspace/${organizationId}/modify_subscription`,
  organization: `${restApiUrl}workspace/${organizationId}`,
  organizationDomain: `${restApiUrl}signup_workspace/${organizationId}`,
  usage: `${restApiUrl}workspace/${organizationId}/usage`,
  updateOrganization: `${restApiUrl}workspace/${organizationId}`,
  updateOrganizationMemberSettings: `${restApiUrl}workspace/${organizationId}/member_settings`,
  members: `${restApiUrl}workspace/${organizationId}`,
});

export const apiIpEndpoint: IpEndpointUrl = {
  ipEndpoint: `https://pro.ip-api.com/json?key=${ipApiKey}`,
};
